import { render, staticRenderFns } from "./CourseSummary.vue?vue&type=template&id=11700ab8&"
import script from "./CourseSummary.vue?vue&type=script&lang=ts&"
export * from "./CourseSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports